import { memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './Layout.module.css';

import type { FC, ReactElement, ReactNode } from 'react';

interface LayoutProps {
  className?: string;
  cnSidebar?: string;
  cnContent?: string;
  sidebar: ReactElement;
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({
  className,
  sidebar,
  children,
  cnSidebar,
  cnContent,
  ...restProps
}) => {
  return (
    <div {...restProps} className={cn(styles.grid, className)}>
      <div className={cn(styles.mainContent, cnContent)}>{children}</div>
      <div className={cn(styles.wrapperSidebar, cnSidebar)}>
        <div className={styles.sidebarPositioner}>{sidebar}</div>
      </div>
    </div>
  );
};

export default memo(Layout);
